import type { AmbassadorsPageState, ContractModalSource } from './types';

export const mutations = {
	openContractModal: (state: AmbassadorsPageState, source: ContractModalSource): AmbassadorsPageState => ({
		...state,
		contractModal: {
			open: true,
			source,
		},
	}),
	closeContractModal: (state: AmbassadorsPageState): AmbassadorsPageState => ({
		...state,
		contractModal: {
			...state.contractModal,
			open: false,
		},
	}),
};
